module.exports = __webpack_public_path__ + "static/media/fiverr.ad22ed32.jpg";